module.exports = __webpack_public_path__ + "website/img/main04.a966ee22.png";